import React, { useRef, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import Search from "../containers/Search";
import { Search as SearchIcon, X, Menu as MenuIcon } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { setFilterSort } from "../../server/Product";
import { setToggleMenu } from "../../server/CartsOpen";
import ProductFilters from "../routs/categoryPage/ProductFilters";

function isFilterRoute(pathname) {
  return (
    pathname.includes("/category/") ||
    pathname.includes("/search") ||
    pathname.includes("/sales")
  );
}

const HeaderSearch = () => {
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const filterAndSort = useSelector(
    (state) => state.displayProduct?.filterAndSort ?? false,
  );

  const panelRef = useRef(null);

  /* Close panel on click outside (panel is portaled to body). */
  useEffect(() => {
    if (!filterAndSort) return undefined;
    const handler = (e) => {
      const target = e.target;
      if (panelRef.current?.contains(target)) return;
      if (target.closest?.(".desk-search") || target.closest?.(".search-cont"))
        return;
      if (target.closest?.(".search-icon-btn--filter")) return;
      if (target.closest?.(".filter-and-sort")) return;
      dispatch(setFilterSort(false));
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [filterAndSort, dispatch]);

  const close = () => dispatch(setFilterSort(false));

  const showPanel = filterAndSort && isFilterRoute(pathname);

  const panel =
    showPanel && typeof document !== "undefined"
      ? createPortal(
          <div
            ref={panelRef}
            className="search-dropdown-panel"
            dir="rtl"
            role="dialog"
            aria-modal="true"
            aria-label="מיון וסינון"
          >
            <header className="cart-drawer__head">
              <div className="cart-drawer__head-text">
                <h2 className="cart-drawer__head-title">מיון וסינון</h2>
              </div>
              <button
                type="button"
                className="cart-drawer__head-close"
                onClick={close}
                aria-label="סגור"
              >
                <X size={20} strokeWidth={2} aria-hidden />
              </button>
            </header>

            <div className="cart-drawer__body cart-drawer__body--filters">
              <div className="cart-drawer__filters-scroll">
                <ProductFilters />
              </div>
            </div>
          </div>,
          document.body,
        )
      : null;

  return (
    <>
      <div className="desk-search">
        <div className="desk-search__bar">
          <button
            type="button"
            className="mobile-hamburger-btn"
            onClick={() => dispatch(setToggleMenu())}
            aria-label="פתח תפריט"
          >
            <MenuIcon size={22} strokeWidth={2} aria-hidden />
          </button>
          <Search />
        </div>
      </div>

      {panel}

      {/* Mobile: icon that toggles the search bar */}
      <div className="mobile-search">
        <button
          className="icon"
          onClick={() => setShowMobileSearch(!showMobileSearch)}
          type="button"
          aria-label="חיפוש"
        >
          <SearchIcon aria-hidden size={22} strokeWidth={2} />
        </button>
        {showMobileSearch ? (
          <div className="search">
            <Search />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default HeaderSearch;
